import * as React from 'react'
import { IconProps } from './types'

export const TimelineConnector = ({ title, ...rest }: IconProps) => (
  <svg width='auto' height='auto' viewBox='0 0 1 90' fill='none' xmlns='http://www.w3.org/2000/svg' {...rest}>
    <title>{title || ''}</title>
    <line x1='0.5' y1='-2.18557e-08' x2='0.500004' y2='90' stroke='#D5D6D9' />
  </svg>
)
